var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M469.3,122.1V42.4c0-11.8-9.5-21.3-21.3-21.3c-11.8,0-21.3,9.5-21.3,21.3v50.8l-111-74.9 c-36.2-24.4-83.1-24.4-119.3,0L47,119c-29.4,19.8-47,52.9-47,88.4v197.9C0,464.1,47.9,512,106.7,512h298.7 c58.8,0,106.7-47.9,106.7-106.7V207.4C512,173.7,496.1,142.2,469.3,122.1L469.3,122.1z M469.3,405.3c0,35.3-28.7,64-64,64H106.7 c-35.3,0-64-28.7-64-64V207.4c0-21.3,10.5-41.2,28.2-53L220.2,53.6c10.9-7.4,23.3-11,35.8-11s24.9,3.7,35.8,11l149.4,100.8 c17.6,11.9,28.2,31.7,28.2,53L469.3,405.3L469.3,405.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.7edcc21d458173bc598f44526afe1cb8.svg";
export { ForwardRef as ReactComponent };